import { format } from "date-fns";
import { ClassNames, DayPicker, Matcher } from "react-day-picker";
import { useTranslation } from "react-i18next";

interface DatePickerProps {
  selected: Date;
  onSelect: (date: Date) => void;
  disabled?: Matcher | Matcher[] | undefined;
  classNames?: Partial<ClassNames> | undefined;
}

function DatePicker({
  selected,
  onSelect,
  disabled,
  classNames,
}: DatePickerProps) {
  const { t } = useTranslation(["dashboardPage"]);
  return (
    <>
      <div className={"dropdown"}>
        <div
          // biome-ignore lint/a11y/useSemanticElements: workaround Safari bug https://daisyui.com/components/dropdown/#method-3-css-focus
          tabIndex={0}
          role="button"
          className={`btn w-[280px] justify-start text-left font-normal ${!selected && "text-muted-foreground"}`}
        >
          {selected ? (
            format(selected, "PPP")
          ) : (
            <span>{t("chatAnalytics.pickDate")}</span>
          )}
        </div>
        <div className="dropdown-content" tabIndex={-1}>
          <DayPicker
            className="react-day-picker"
            mode="single"
            selected={selected}
            onSelect={onSelect}
            required={true}
            disabled={disabled}
            classNames={classNames}
          />
        </div>
      </div>
    </>
  );
}

export default DatePicker;
